import { ONE_LINE_CHARACTERS_LIMIT } from './constants'

export const prepareText = ({ expanded, text }: { expanded: boolean; text: string }): string => {
  if (expanded || text.length <= ONE_LINE_CHARACTERS_LIMIT) {
    return text
  } else {
    return `${text.slice(0, ONE_LINE_CHARACTERS_LIMIT)}...`
  }
}
